export default __webpack_public_path__ + "static/media/time.08157a37.png";